import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import type {
  ScoreDto,
  ScoresControllerListParams,
} from '../../../core/generated-api/sbe-conduct/models';
import { ScoresService } from '../../../core/generated-api/sbe-conduct/scores';

/**
 * 학생 점수 — `GET /orgs/:orgId/scores`(교직원 전용, `memberIds`로 좁힐 수 있다),
 * `GET /me/orgs/:orgId/scores`(본인), `GET …/teams/:teamId/scores`(반). 교직원용 응답은 이름·반이 없어 명단과
 * `memberId`로 합쳐 쓰고, 행이 없는 학생은 0점이다(INTEGRATION.md 「학생 상벌점 조회」).
 * 본인 조회는 자리 이름·반·자격(`relation`)을 함께 주므로 명단 없이 그대로 쓴다 — 보호자는 명단 API를 못 읽는다.
 */
@Injectable({ providedIn: 'root' })
export class ConductScoresService {
  private readonly api = inject(ScoresService);

  readonly scores = signal<ScoreDto[]>([]);

  // Only the latest refresh lands; an older answer (e.g. for the previous school) is dropped.
  private latestRefresh = 0;

  async refresh(orgId: string, query: ScoresControllerListParams = {}) {
    const call = ++this.latestRefresh;

    const request = this.api.scoresControllerList(orgId, query);
    const { items } = await firstValueFrom(request);

    if (call !== this.latestRefresh) return;

    this.scores.set(items);
  }

  listMine(orgId: string) {
    const request = this.api.meScoresControllerList(orgId);

    return firstValueFrom(request);
  }

  listTeam(orgId: string, teamId: string) {
    const request = this.api.teamScoresControllerList(orgId, teamId);

    return firstValueFrom(request);
  }
}
